export const PREVENT_CLOSE_CLASS = 'ui-toggle-prevent-close';

export const LIFECYCLE_HOOKS = {
    WILL_OPEN: 'togglerWillOpen',
    DID_OPEN: 'togglerDidOpen',
    WILL_CLOSE: 'togglerWillClose',
    DID_CLOSE: 'togglerDidClose'
};

export const SHOULD_PREVENT_CLOSE_ACTION = 'shouldPreventCloseAction';
